import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Reason For Leaving\n          ")
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-700 text-sm" }, "\n          If the employee is moving to another part of the business without a break in service then please do not\n          submit a leaver form.\n        ", -1);
const _hoisted_6 = { class: "col-span-6 flex" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "reason",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Reason for leaving EQUANS: *\n            ", -1);
const _hoisted_8 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_12 = {
    key: 0,
    class: "mt-1 ml-4 sm:mt-0 sm:col-span-2"
};
const _hoisted_13 = {
    for: "reasonMore",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = ["value"];
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Comments", -1);
const _hoisted_18 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_19 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _hoisted_5,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_8, [
                            _withDirectives(_createElementVNode("select", {
                                id: "reason",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.reason) = $event)),
                                name: "reason",
                                autocomplete: "reason-name",
                                class: _normalizeClass(["max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.reason.$error,
                                        'border-red-500': _ctx.v$.formData.reason.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.reason.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasonsForLeaving, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: item.id,
                                        value: item.name
                                    }, _toDisplayString(item.name), 9, _hoisted_10));
                                }), 128))
                            ], 42, _hoisted_9), [
                                [_vModelSelect, _ctx.formData.reason]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.reason.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\n                * " + _toDisplayString(_ctx.v$.formData.reason.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.reason)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, "Reason for " + _toDisplayString(_ctx.formData.reason) + " *", 1),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("select", {
                                id: "reasonMore",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.reasonResignation) = $event)),
                                name: "reasonMore",
                                autocomplete: "reason-name",
                                class: _normalizeClass(["max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.reasonResignation.$error,
                                        'border-red-500': _ctx.v$.formData.reasonResignation.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.reasonResignation.$touch()))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reason.Items, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: item.id,
                                        value: item.name
                                    }, _toDisplayString(item.name), 9, _hoisted_15));
                                }), 128))
                            ], 42, _hoisted_14), [
                                [_vModelSelect, _ctx.formData.reasonResignation]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.reasonResignation.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n              * " + _toDisplayString(_ctx.v$.formData.reasonResignation.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_17,
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("textarea", {
                        id: "reason-comments",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.comments) = $event)),
                        name: "comments",
                        rows: "3",
                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                    }, null, 512), [
                        [_vModelText, _ctx.formData.comments]
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_19)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
